export default __webpack_public_path__ + "media/images/brands/alessi-3abffa5c99ba47a44291bce2fd4f6b79.png";